import React from 'react';
import { Control } from 'react-hook-form';
import { StyleProp, ViewStyle } from 'react-native';
import { View } from 'react-native-animatable';
import { SharedFormField } from '@/components/SharedComponents/FormField/SharedFormField';

interface LoginFormData {
  email: string;
  password: string;
  twoFAToken?: string;
  app?: string;
  deviceModel?: string;
  shortLivedSession?: boolean;
  deviceToken?: string;
  loginChannel?: string;
}

interface LoginFormInputsProps {
  control: Control<LoginFormData>;
  customStyles?: StyleProp<ViewStyle>;
}

export const LoginFormInputs: React.FC<LoginFormInputsProps> = ({
  control,
  customStyles,
}) => {
  return (
    <View style={customStyles}>
      <SharedFormField
        control={control}
        name="email"
        label="E-Mail-Adresse"
        useEmailInput
        rules={{
          required: 'Pflichtfeld',
          pattern: {
            // Email address validation regex according to RFC 5322 Official Standard: https://emailregex.com/
            value:
              /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x7f])+)\])/gi,
            message: 'E-Mail-Adresse ungültig',
          },
        }}
      />
      <SharedFormField
        control={control}
        name="password"
        label="Passwort"
        rules={{ required: 'Pflichtfeld' }}
        secureTextEntry
        usePasswordInput
      />
    </View>
  );
};
